import React from 'react';
import { Menu, X, Shield, ChevronLeft, Sun, Moon, Sparkles, Palette } from 'lucide-react';

const TopBar = ({ 
    isSidebarOpen, 
    setSidebarOpen, 
    selectedTenantId, 
    resetTenant, 
    navigate, 
    t, 
    theme, 
    toggleTheme, 
    i18n, 
    toggleLanguage, 
    userData, 
    tenantData, 
    setIsAIChatOpen, 
    handleOpenProfile,
    userInitials,
    displayName
}) => {
    return (
        <header className="top-bar">
            <style>{`
                @media (max-width: 480px) {
                    .impersonation-badge { display: none !important; }
                    .impersonation-back span { display: none; }
                    .topbar-controls { gap: 0.5rem !important; }
                    .topbar-theme-toggle { margin-right: 0.25rem !important; }
                }
            `}</style>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: 0 }}>
                <button
                    onClick={() => setSidebarOpen(!isSidebarOpen)}
                    style={{
                        background: 'transparent',
                        color: 'var(--text-main)',
                        padding: '8px',
                        border: 'none',
                        cursor: 'pointer',
                        flexShrink: 0
                    }}
                >
                    {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
                </button>

                {selectedTenantId && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                        <div className="impersonation-badge" style={{
                            background: '#fef3c7',
                            color: '#92400e',
                            padding: '4px 10px',
                            borderRadius: '6px',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            whiteSpace: 'nowrap'
                        }}>
                            <Shield size={14} /> {t('common.impersonationMode', 'IMPERSONATION MODE')}
                        </div>
                        <button
                            className="impersonation-back"
                            onClick={() => { resetTenant(); navigate('/app/admin'); }}
                            style={{
                                background: 'transparent',
                                color: 'var(--primary)',
                                border: '1px solid var(--primary)',
                                padding: '4px 10px',
                                fontSize: '0.75rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <ChevronLeft size={14} /> <span>{t('common.backToAdmin', 'Back to Admin')}</span>
                        </button>
                    </div>
                )}
            </div>

            <div className="topbar-controls" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0 }}>
                <div className="topbar-theme-toggle" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2px',
                    padding: '4px',
                    background: 'var(--bg-card)',
                    borderRadius: '50px',
                    border: '1px solid var(--border)',
                    marginRight: '0.875rem',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                    height: '42px'
                }}>
                    <button
                        onClick={toggleTheme}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            color: 'var(--text-main)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s',
                            padding: 0
                        }}
                        title={theme.mode === 'dark' ? 'Açık Tema' : 'Koyu Tema'}
                    >
                        {theme.mode === 'dark' ? (
                            <Sun size={22} strokeWidth={3} />
                        ) : (
                            <Moon size={20} strokeWidth={3} />
                        )}
                    </button>
                    <div style={{ width: '1px', height: '18px', background: 'var(--border)', margin: '0 2px' }}></div>
                    <button
                        onClick={toggleLanguage}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            color: 'var(--text-main)',
                            cursor: 'pointer',
                            fontSize: '0.8125rem',
                            fontWeight: 900,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0
                        }}
                        title="Dili Değiştir"
                    >
                        {i18n.language === 'tr' ? 'EN' : 'TR'}
                    </button>
                </div>

                {/* AI Advisor - Only for Premium Plan or SuperAdmin */}
                {((tenantData?.plan === 'premium') || (userData?.isSuperAdmin && !selectedTenantId)) && (
                    <button
                        onClick={() => setIsAIChatOpen(true)}
                        className="ai-chat-btn"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '10px 24px',
                            borderRadius: '50px',
                            background: 'linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%)',
                            color: 'white',
                            border: 'none',
                            fontWeight: 800,
                            fontSize: '0.9375rem',
                            cursor: 'pointer',
                            boxShadow: '0 4px 15px rgba(var(--primary-rgb), 0.3)',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        <Sparkles size={18} />
                        <span style={{ letterSpacing: '0.02em' }}>AI Danışman</span>
                    </button>
                )}

                <div className="user-profile glass" onClick={handleOpenProfile}>
                    <div className="avatar">{userInitials}</div>
                    <div style={{ fontSize: '0.875rem' }}>
                        <div style={{ fontWeight: 600 }}>{displayName}</div>
                        <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>
                            {userData?.position || userData?.role || 'User'}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default TopBar;
